<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-6 col-sm-10 col-12">
        <div class="d-sm-flex justify-content-center">
          <div class="my-auto ms-auto">
            <!-- <soft-button class="mt-2" color="danger" variant="gradient" size="sm" data-bs-toggle="modal" data-bs-target="#deleteEntityModal">Eliminar
            </soft-button> -->
            <soft-button class="mt-2" color="danger" variant="gradient" size="sm" @click="showModalNotification()">Eliminar
            </soft-button>
          </div>
        </div>
        <div class="card mt-4">
          <div class="card-body p-5 ">
            <div class="row">
              <form ref='deletesForm' class="needs-validation h-100" novalidate>
                <div>
                  <label>Cliente <span style="color:red">*</span> </label>
                  <select
                      id="choices-customer"
                      v-model="localValue.customer_id"
                      class="form-control"
                      name="choices-customer"
                      required
                    >
                      <option v-for="item in clientOptions" :key="item.value" :value="item.value"> {{ item.label }}</option>
                    </select>
                </div>
                <div class="mt-3">
                  <label>Entidad <span style="color:red">*</span> </label>
                  <select
                      id="choices-entity"
                      v-model="localValue.entity"
                      class="form-control"
                      name="choices-entity"
                      required
                    >
                      <option v-for="item in entitiesOptions" :key="item.value" :value="item.value"> {{ item.label }}</option>
                    </select>
                </div>
                <div v-if="localValue.entity=='products'" class="row m-3">
                  <div class="col-6 my-auto form-check">
                    <label for="customCheck1">Borrar Todos</label>
                    <input id="customCheck1" v-model="localValue.all" class="form-check-input" type="checkbox" />
                  </div>
                  <div  class="col-6 my-auto form-check">
                    <label for="customCheck2">Borrar No Registrados</label>
                    <input id="customCheck2" v-model="deleteNoRegisterProduct" class="form-check-input" type="checkbox" />
                  </div>
                </div>
                <div class="">
                  <div class="form-group">
                    <label for="numbers">Números <span style="color:red">*</span></label>
                    <textarea id="numbers" v-model="localValue.identifiers" class="form-control" placeholder="Indique los números de las entidades a eliminar separados por punto coma!"
                    :required="inputRequired" :readonly="textareaRead" rows="6"></textarea>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
  <Modal-delete-confirmation @confirm-delete="save()" />
</template>

<script>
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import ModalDeleteConfirmation from "./ModalDeleteConfirmation.vue";

  export default {
    components: {
      SoftSnackbar,
      SoftButton,
      ModalDeleteConfirmation
    },
    data() {
      return {
        localValue: {
          customer_id: '',
          entity: '',
          identifiers: '',
          all: false
        },
        entitiesOptions: [{
            value: 'products',
            label: 'Atículos',
          },
          {
            value: 'orders',
            label: 'Pedidos',
          },
          {
            value: 'orders_back',
            label: 'Devoluciones',
          },
          {
            value: 'purchases',
            label: 'Entradas de Proveedor',
          },
          {
            value: 'shipments',
            label: 'Envíos',
          }
        ],
        clientOptions: [],
        inputRequired: true,
        textareaRead: false,
        notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      deleteNoRegisterProduct: true
      }
    },

    computed: {
      clients() {
        return this.$store.state.customer.list.data;
      },
      deleteStatus(){
        return this.$store.state.administration.deleted.status;
      }
    },
    watch: {
      clients(values) {
        if (values) {
          let elements = [];
          for (let cliente of values.items) {
            if (cliente.name == 'CENTRAL')
              continue;
            elements.push({
              label: cliente.customer_sga,
              value: cliente._id
            })
          }
          this.clientOptions = elements;
        }
      },
      'localValue.entity'(value) {
        if (value == 'products' && this.localValue.all) {
          this.inputRequired = false
        }
        else{
          this.localValue.all=false
          this.inputRequired = true
          this.textareaRead=false
        }

      },
      'localValue.all'(value) {
        if (value) {
          this.localValue.identifiers = '';
          this.textareaRead = true;
        } else {
          this.inputRequired=true
          this.textareaRead = false;
        }
      },
      deleteStatus(newValue){
        let data= this.$store.state.administration.deleted.data;
        if (newValue.deleted) {
          this.notificationInfo = {
            title: 'Genial!',
            message: 'Se han eliminado '+data.deletedCount +' registros' ,
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotification();
          setTimeout(() => {
            this.cleanForm();
            }, 200);
      } else if (newValue.error) {
        let message="Ha ocurrido un error al eliminar";
        const error= newValue.error.error;
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
      }
    },
    mounted() {
      this.getCustomers();
    },
    methods: {
      getCustomers() {
        let filter = {
          sort: {
            sort: 'customer_sga',
            order: 'ascending'
          }
        }
        this.$store.commit("customer/load", {
          filters: filter
        });
      },
      save() {
        let form = this.$refs.deletesForm;
        form.classList.add('was-validated');
        if (form.checkValidity()) {
          let contract= this.localValue;
          if (this.localValue.entity=== 'products'){
            contract.no_registered= this.deleteNoRegisterProduct
          }
          this.$store.commit("administration/deleteEntities", contract)
          form.classList.remove('was-validated');
        }
      },
      showModalNotification(){
        let form = this.$refs.deletesForm;
        const bootstrap = this.$store.state.bootstrap;

        form.classList.add('was-validated');
        if (form.checkValidity()) {
          const modal = new bootstrap.Modal(document.getElementById('deleteEntityModal'));
          modal.show();
        }
        return
      },
      closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
        },2500);
      },
      cleanForm(){
        this.localValue= {
          customer_id: '',
          entity: '',
          identifiers: '',
          all: false
        }
        this.deleteNoRegisterProduct= true
      }
    },
  }
</script>

<style>

</style>